export const SET_NEW_LANGUAGE = 'SET-NEW-LANGUAGE';
export const SET_CV_LINK = 'SET-CV-LINK';